import {
  CollapsiblePanel,
  EmptyCell,
  MonoCell,
  PanelCount,
  PanelSummary,
  Table,
  TableWrap,
  Td,
  Th,
} from '../AuditSection';
import { EMPTY_VALUE, WEBHOOK_EMPTY_MESSAGE, WEBHOOK_PANEL_TITLE } from '../constants';
import { displayOrDash, formatShortDateTime } from '../utils';
import { ProcessingChip } from './styled';
import type { WebhookEventsProps } from './types';
import { getWebhookPanelCountLabel, getWebhookProcessingTone } from './utils';

const WebhookEvents = ({ events, loading = false }: WebhookEventsProps) => {
  const countLabel = getWebhookPanelCountLabel(events.length);

  return (
    <CollapsiblePanel open={events.length > 0}>
      <PanelSummary>
        {WEBHOOK_PANEL_TITLE}
        <PanelCount>{loading ? 'Loading…' : countLabel}</PanelCount>
      </PanelSummary>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <Th>Timestamp</Th>
              <Th>Type</Th>
              <Th>I3Screen status</Th>
              <Th>Processing</Th>
              <Th>Error</Th>
            </tr>
          </thead>
          <tbody>
            {events.length === 0 ? (
              <tr>
                <EmptyCell colSpan={5}>{WEBHOOK_EMPTY_MESSAGE}</EmptyCell>
              </tr>
            ) : (
              events.map((event) => {
                const tone = getWebhookProcessingTone(event.processing_status);
                return (
                  <tr key={event.id}>
                    <Td>{formatShortDateTime(event.timestamp)}</Td>
                    <MonoCell>{displayOrDash(event.type)}</MonoCell>
                    <MonoCell>{displayOrDash(event.i3_screen_status)}</MonoCell>
                    <Td>
                      <ProcessingChip tone={tone}>{event.processing_status || EMPTY_VALUE}</ProcessingChip>
                    </Td>
                    <Td>{displayOrDash(event.error_description)}</Td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </TableWrap>
    </CollapsiblePanel>
  );
};

export default WebhookEvents;
